import React, { useEffect, useState } from "react";
// import Heading from "../../components/Heading";
import { Form, Button, Row, Col, Input, Select, message, Spin } from "antd";
// import { ColumnHeightOutlined } from "@ant-design/icons";
import {
  checkSpecialCharacter,
  checkNumbervalue,
  checkSpace,
} from "../../utils";
import Heading from "./Heading";
import { getPremiseId } from "../../utils/worker";

import API from "../../api";
import urls from "../../api/urls";
const { PERSONAL_DETAILS } = urls;
const premiseId = getPremiseId().split("Bearer ")[1];

function NewMiscellaneous({ handleStepsChange, goBackStep }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoading(true);
    let response = await API.Api(
      PERSONAL_DETAILS + "/" + premiseId
    ).getWithPremiseHeader();

    if (response?.status) {
      setLoading(false);

      let data = response?.response?.data;
      form.setFieldsValue({
        industryExperience: data?.industryExperience,
        previousCompany: data?.previousCompany,
        monthlyTurnover: data?.monthlyTurnover,
        officeownership: data?.officeownership,
        officeAreaSize: data?.officeAreaSize,
        staffSize: data?.staffSize,
      });
    } else {
      setLoading(false);
    }
  };

  const onFinish = async (val) => {
    let response = await API.Api(PERSONAL_DETAILS).postWithPrmiseHeader(val);
    if (response?.status) {
      message.success(
        response?.response?.data?.message || "Updated successfully."
      );
      handleStepsChange();
    } else {
      message.error(
        response?.response?.data?.message || "Can't update personal details."
      );
    }
  };
  const md = 12;
  const lg = 12;
  const xl = 12;
  const sm = 12;

  return (
    <div className="p-5-box">
      <Spin spinning={loading}>
        <Heading title={"Miscellaneous Details"} />
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          className="global-form"
        >
          <Row
            gutter={12}
            style={{ paddingBottom: "20px" }}
            className="global-form-row"
          >
            <Col md={md} xl={xl} sm={sm} lg={lg}>
              <Form.Item
                name="industryExperience"
                label={"Experience in courier industry (in years)"}
                onKeyPress={(event) => {
                  if (checkNumbervalue(event) || checkSpace(event)) {
                    event.preventDefault();
                  }
                }}
                rules={[
                  {
                    pattern: /^[0-9].*/g,
                    message: "Initial value should be numeric.",
                  },
                  {
                    pattern: /^\d{1,2}(\.\d{0,2})?$/,
                    message: "Invalid experience",
                  },
                ]}
              >
                <Input
                  placeholder="0"
                  type="text"
                  maxLength={5}
                  //className="input-field-style"
                  onKeyPress={(e) => {
                    if (/[^0-9.]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col md={md} xl={xl} sm={sm} lg={lg}>
              <Form.Item
                name="previousCompany"
                label={"Name of the previous courier company"}
              >
                <Input
                  placeholder="Enter previous company name"
                  type="text"
                  maxLength={50}
                  //className="input-field-style"
                />
              </Form.Item>
            </Col>
            <Col md={md} xl={xl} sm={sm} lg={lg}>
              <Form.Item
                name="monthlyTurnover"
                label={"Monthly turnover (approximate)"}
                onKeyPress={(event) => {
                  if (checkNumbervalue(event) || checkSpace(event)) {
                    event.preventDefault();
                  }
                }}
                rules={[
                  {
                    pattern: /^\d{1,10}(\.\d{0,2})?$/,
                    message: "Invalid turnover",
                  },
                  () => ({
                    validator(rule, value = "") {
                      if (value.substring(1, 0) === " ") {
                        return Promise.reject("Invalid turnover");
                      } else {
                        return Promise.resolve();
                      }
                    },
                  }),
                ]}
              >
                <Input
                  placeholder="0"
                  type="text"
                  maxLength={20}
                  className="input-field-style"
                />
              </Form.Item>
            </Col>
            <Col md={md} xl={xl} sm={sm} lg={lg}>
              <Form.Item
                name="officeownership"
                label={
                  <span className="calculater-container-pikpin">
                    Office ownership
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: "Please select value",
                  },
                ]}
              >
                <Select
                  placeholder="Select ownership"
                  options={[
                    {
                      value: "Owned",
                      label: "Owned",
                    },
                    {
                      value: "Rented",
                      label: "Rented",
                    },
                  ]}
                  //className="input-field-style"
                />
              </Form.Item>
            </Col>
            <Col md={md} xl={xl} sm={sm} lg={lg}>
              <Form.Item
                name="officeAreaSize"
                label={"Office area in sq. ft."}
                onKeyPress={(event) => {
                  if (checkNumbervalue(event) || checkSpace(event)) {
                    event.preventDefault();
                  }
                }}
                rules={[
                  {
                    required: true,
                    message: "Please enter value",
                  },
                  {
                    pattern: /^\d{1,10}(\.\d{0,2})?$/,
                    message: "Invalid office area",
                  },
                  () => ({
                    validator(rule, value = "") {
                      if (value.substring(1, 0) === " ") {
                        return Promise.reject("Invalid Office area");
                      } else {
                        return Promise.resolve();
                      }
                    },
                  }),
                ]}
              >
                <Input
                  placeholder="0"
                  type="text"
                  maxLength={20}
                  //className="input-field-style"
                />
              </Form.Item>
            </Col>
            <Col md={md} xl={xl} sm={sm} lg={lg}>
              <Form.Item
                name="staffSize"
                label={"No. of staff"}
                onKeyPress={(event) => {
                  if (
                    checkNumbervalue(event) ||
                    checkSpecialCharacter(event) ||
                    checkSpace(event)
                  ) {
                    event.preventDefault();
                  }
                }}
                rules={[
                  {
                    required: true,
                    message: "Please select value",
                  },
                ]}
              >
                <Input
                  placeholder="Enter number of staff"
                  type="text"
                  maxLength={3}
                  //className="input-field-style"
                />
              </Form.Item>
            </Col>
          </Row>

          <hr
            className="divider"
            style={{ marginTop: "20px", marginBottom: "30px" }}
          />
          <Row gutter={12} justify="end">
            <Col>
              <Button className="cancel-btn" onClick={goBackStep}>
                BACK
              </Button>
            </Col>
            <Col>
              <Button className="save-btn" htmlType="submit">
                SAVE
              </Button>
            </Col>
          </Row>
        </Form>
      </Spin>
    </div>
  );
}

export default NewMiscellaneous;
